var _path, _polygon, _path2, _rect, _polygon2, _path3, _polygon3, _path4, _rect2, _polygon4, _rect3, _path5, _polygon5, _rect4, _path6, _polygon6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImg7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "120.55 47.74 278.07 423.55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M285.8,334.72l1.69,14.6c0,39.3-1.38,42.22-4.67,55.87-1.15,4.76-2.56,10.06-4.2,14.81a24.79,24.79,0,0,0-1.11,4.65v.07a26.58,26.58,0,0,0-.3,3.88,51.54,51.54,0,0,1-2.28,14.86c-1.75,6-4,12.82-6.51,20.05a219.71,219.71,0,0,1-72.73,7.28l23.4-43.18a22.47,22.47,0,0,0,2.36-14.7c-3-16.61-6.8-41.73-7.52-66.27-1.12-38.25,1.43-31.33,2.58-49.37A16,16,0,0,1,222.19,286l1.4-1.16,14.18-29.4a15.12,15.12,0,0,1,21.56-6.3l14.15,8.73a2.39,2.39,0,0,1,1.12,1.76l1.9,16.25s10.3,15.5,11,21.5c.22,2-1.9,7.67-1.9,7.67Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-2--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M268.41,463.51c2.52-7.23,4.76-14.08,6.51-20.05a51.54,51.54,0,0,0,2.28-14.86,26.58,26.58,0,0,1,.3-3.88v-.07a24.79,24.79,0,0,1,1.11-4.65c1.64-4.75,3.05-10.05,4.2-14.81,3.29-13.65,4.66-16.57,4.67-55.87l-1.69-14.6-.21-29.63s2.12-5.71,1.9-7.67c-.69-6-11-21.5-11-21.5l-1.9-16.25a2.39,2.39,0,0,0-1.12-1.76l-14.15-8.73a15.11,15.11,0,0,0-21.56,6.3l-14.18,29.4-1.4,1.16a16,16,0,0,0-5.69,11.23c-1.15,18-3.7,11.12-2.58,49.37.72,24.54,4.5,49.66,7.52,66.27a22.47,22.47,0,0,1-2.36,14.7l-23.4,43.18",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Metrics--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M387.36,241.72H131a10.34,10.34,0,0,1-10.34-10.34V65.1A10.33,10.33,0,0,1,131,54.77H387.36A10.33,10.33,0,0,1,397.7,65.1V231.38A10.34,10.34,0,0,1,387.36,241.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.36,235.74H131a10.34,10.34,0,0,1-10.34-10.34V59.12A10.34,10.34,0,0,1,131,48.79H387.36A10.34,10.34,0,0,1,397.7,59.12V225.4A10.34,10.34,0,0,1,387.36,235.74Z",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.12,64.57v-6a10.33,10.33,0,0,0-10.34-10.33H131.39a10.33,10.33,0,0,0-10.34,10.33V224.87h0v6a10.34,10.34,0,0,0,10.34,10.34H387.78a10.34,10.34,0,0,0,10.34-10.34V64.57Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.14,65.29V218.17h243V65.29Zm240.3,30H350.09V68h27.35ZM199.9,128.06h27.35v27.35H199.9Zm-2.69,27.35H169.87V128.06h27.34Zm90.12-30H260V98h27.34ZM290,98h27.34v27.35H290Zm-30,30h27.35v27.35H260Zm-2.69,27.35H229.94V128.06h27.35Zm0-30H229.94V98h27.35Zm-30,0H199.9V98h27.35Zm0,32.73v27.34H199.9V158.1Zm2.69,0h27.35v27.34H229.94Zm30,0h27.35v27.34H260Zm30,0h27.34v27.34H290Zm0-2.69V128.06h27.34v27.35Zm30-27.35H347.4v27.35H320.05Zm0-2.69V98H347.4v27.35Zm0-30V68H347.4V95.33Zm-2.69,0H290V68h27.34Zm-30,0H260V68h27.34Zm-30,0H229.94V68h27.35Zm-30,0H199.9V68h27.35Zm-30,0H169.87V68h27.34Zm0,2.69v27.35H169.87V98Zm-30,27.35H139.83V98h27.35Zm0,2.69v27.35H139.83V128.06Zm0,30v27.34H139.83V158.1Zm2.69,0h27.34v27.34H169.87Zm27.34,30v27.35H169.87V188.13Zm2.69,0h27.35v27.35H199.9Zm30,0h27.35v27.35H229.94Zm30,0h27.35v27.35H260Zm30,0h27.34v27.35H290Zm30,0H347.4v27.35H320.05Zm0-2.69V158.1H347.4v27.34Zm30-27.34h27.35v27.34H350.09Zm0-2.69V128.06h27.35v27.35Zm0-30V98h27.35v27.35ZM167.18,68V95.33H139.83V68ZM139.83,188.13h27.35v27.35H139.83Zm210.26,27.35V188.13h27.35v27.35Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.14,65.29V218.17h243V65.29Zm240.3,30H350.09V68h27.35ZM199.9,128.06h27.35v27.35H199.9Zm-2.69,27.35H169.87V128.06h27.34Zm90.12-30H260V98h27.34ZM290,98h27.34v27.35H290Zm-30,30h27.35v27.35H260Zm-2.69,27.35H229.94V128.06h27.35Zm0-30H229.94V98h27.35Zm-30,0H199.9V98h27.35Zm0,32.73v27.34H199.9V158.1Zm2.69,0h27.35v27.34H229.94Zm30,0h27.35v27.34H260Zm30,0h27.34v27.34H290Zm0-2.69V128.06h27.34v27.35Zm30-27.35H347.4v27.35H320.05Zm0-2.69V98H347.4v27.35Zm0-30V68H347.4V95.33Zm-2.69,0H290V68h27.34Zm-30,0H260V68h27.34Zm-30,0H229.94V68h27.35Zm-30,0H199.9V68h27.35Zm-30,0H169.87V68h27.34Zm0,2.69v27.35H169.87V98Zm-30,27.35H139.83V98h27.35Zm0,2.69v27.35H139.83V128.06Zm0,30v27.34H139.83V158.1Zm2.69,0h27.34v27.34H169.87Zm27.34,30v27.35H169.87V188.13Zm2.69,0h27.35v27.35H199.9Zm30,0h27.35v27.35H229.94Zm30,0h27.35v27.35H260Zm30,0h27.34v27.35H290Zm30,0H347.4v27.35H320.05Zm0-2.69V158.1H347.4v27.34Zm30-27.34h27.35v27.34H350.09Zm0-2.69V128.06h27.35v27.35Zm0-30V98h27.35v27.35ZM167.18,68V95.33H139.83V68ZM139.83,188.13h27.35v27.35H139.83Zm210.26,27.35V188.13h27.35v27.35Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.85 157.7 257.68 155.8 259.85 153.9 262.02 155.8 259.85 157.7",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.35,152l-2.17-1.9,4.34-3.8,2.16,1.9Zm8.67-7.6-2.17-1.91,4.33-3.8,2.17,1.9Zm8.66-7.61-2.17-1.9,4.34-3.8L288,133Zm8.67-7.6-2.17-1.9,1.91-1.68,3.51-1.54,1.37,2.41-3.06,1.34Zm10.1-5.12-1.37-2.4,5.48-2.41,1.37,2.41Zm11-4.8L312,116.86l5.48-2.41,1.37,2.41Zm11-4.81L323,112.05l3.33-1.46,1.35-1.18,2.17,1.9-1.7,1.49Zm9.81-6.95-2.17-1.9,4.34-3.81,2.16,1.91Zm8.67-7.61L340.68,98,345,94.2l2.17,1.9Zm8.66-7.6-2.17-1.9,4.34-3.8,2.16,1.9Zm8.67-7.6L358,82.8l4.33-3.8,2.17,1.9Zm8.66-7.6-2.17-1.91,4.34-3.8,2.17,1.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "380.13 76.52 377.06 76.52 377.06 67.98 367.34 67.98 367.34 65.3 380.13 65.3 380.13 76.52",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M340.33,137l-1.9-1.9,3.75-3.75,1.9,1.9Zm7.5-7.5-1.9-1.9,3.75-3.75,1.9,1.9Zm7.5-7.5-1.9-1.9,3.75-3.75,1.9,1.9Zm7.5-7.5-1.9-1.9,3.75-3.75,1.9,1.9Zm7.5-7.5-1.9-1.9,3.75-3.75,1.9,1.9Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "334.28 143.08 331.04 143.08 331.04 140.39 333.17 140.39 334.68 138.88 336.58 140.78 334.28 143.08"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M289.23,158.1h-2.6v-2.69h1.48l1.75-1.75,1.9,1.9Zm-7.66,0h-5.06v-2.69h5.06Zm-10.12,0h-5.07v-2.69h5.07ZM295.34,152l-1.9-1.9L297,146.5l1.9,1.9Zm7.16-7.15-1.9-1.91,2.53-2.53h2.59v2.69h-1.47ZM326,143.08h-5.06v-2.69H326Zm-10.12,0h-5.06v-2.69h5.06Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 258.63,
    y: 155.41,
    width: 2.69,
    height: 2.69
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "380.13 106.55 377.44 106.55 377.44 98.02 368.9 98.02 368.91 95.33 380.13 95.33 380.13 106.55"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M340.33,137l-1.9-1.9,3.75-3.75,1.9,1.9Zm7.5-7.5-1.9-1.9,3.75-3.75,1.9,1.9Zm7.5-7.5-1.9-1.9,3.75-3.75,1.9,1.9Zm7.5-7.5-1.9-1.9,3.75-3.75,1.9,1.9Zm7.5-7.5-1.9-1.9,3.75-3.75,1.9,1.9Z"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "334.28 143.08 331.04 143.08 331.04 140.39 333.17 140.39 334.68 138.88 336.58 140.78 334.28 143.08"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M289.23,158.1h-2.6v-2.69h1.48l1.75-1.75,1.9,1.9Zm-7.66,0h-5.06v-2.69h5.06Zm-10.12,0h-5.07v-2.69h5.07ZM295.34,152l-1.9-1.9L297,146.5l1.9,1.9Zm7.16-7.15-1.9-1.91,2.53-2.53h2.59v2.69h-1.47ZM326,143.08h-5.06v-2.69H326Zm-10.12,0h-5.06v-2.69h5.06Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 258.63,
    y: 155.41,
    width: 2.69,
    height: 2.69
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "380.13 106.55 377.44 106.55 377.44 98.02 368.9 98.02 368.91 95.33 380.13 95.33 380.13 106.55"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 258.24,
    y: 156.36,
    width: 2.69,
    height: 2.69,
    transform: "translate(-35.48 229.75) rotate(-45)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M299.79,173.12H294.2v-2.69h5.58Zm-11.17,0H283v-2.69h5.59Zm-11.17,0h-4.36l-1.66-1.67,1.91-1.9.87.88h3.24Zm28.38-1.59-1.9-1.9,3.95-3.95,1.9,1.9Zm-38.35-4-4-3.94,1.91-1.91,3.95,3.95Zm46.25-3.87-1.9-1.9,3.95-4,1.9,1.91Zm35.57-5.53h-5.46v-2.69h4.35l.09-.1.09.1h.37v.37l1.44,1.44Zm-11,0h-5.59v-2.69h5.59Zm-11.17,0H321.5v-2.69h5.59Zm27-4.83-1.9-1.91,3.95-3.94,1.9,1.9Zm7.9-7.9-1.9-1.9,3.95-3.95,1.9,1.9Zm7.9-7.9-1.9-1.9,4-3.95,1.9,1.9Z"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "380.13 136.59 377.44 136.59 377.44 128.06 368.9 128.06 368.9 125.37 380.13 125.37 380.13 136.59"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 258.24,
    y: 156.36,
    width: 2.69,
    height: 2.69,
    transform: "translate(-35.48 229.75) rotate(-45)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M299.79,173.12H294.2v-2.69h5.58Zm-11.17,0H283v-2.69h5.59Zm-11.17,0h-4.36l-1.66-1.67,1.91-1.9.87.88h3.24Zm28.38-1.59-1.9-1.9,3.95-3.95,1.9,1.9Zm-38.35-4-4-3.94,1.91-1.91,3.95,3.95Zm46.25-3.87-1.9-1.9,3.95-4,1.9,1.91Zm35.57-5.53h-5.46v-2.69h4.35l.09-.1.09.1h.37v.37l1.44,1.44Zm-11,0h-5.59v-2.69h5.59Zm-11.17,0H321.5v-2.69h5.59Zm27-4.83-1.9-1.91,3.95-3.94,1.9,1.9Zm7.9-7.9-1.9-1.9,3.95-3.95,1.9,1.9Zm7.9-7.9-1.9-1.9,4-3.95,1.9,1.9Z"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "380.13 136.59 377.44 136.59 377.44 128.06 368.9 128.06 368.9 125.37 380.13 125.37 380.13 136.59"
  })))), /*#__PURE__*/React.createElement("polygon", {
    points: "154.34 218.17 138.49 218.17 138.49 215.48 152.67 215.48 167.42 185.99 182.98 170.43 213.02 170.43 228.04 155.41 258.63 155.41 258.63 158.1 229.15 158.1 214.13 173.12 184.1 173.12 169.63 187.59 154.34 218.17",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "154.34 218.17 138.49 218.17 138.49 215.48 152.67 215.48 167.42 185.99 182.98 170.43 213.02 170.43 228.04 155.41 258.63 155.41 258.63 158.1 229.15 158.1 214.13 173.12 184.1 173.12 169.63 187.59 154.34 218.17",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 173.36,
    y: 193.47,
    width: 25.45,
    height: 25.45,
    rx: 4.75,
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.36,
    y: 193.47,
    width: 25.45,
    height: 25.45,
    rx: 4.75,
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.36,
    y: 191.69,
    width: 25.45,
    height: 25.45,
    rx: 4.75,
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.36,
    y: 191.69,
    width: 25.45,
    height: 25.45,
    rx: 4.75,
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M179.34,200.59a3.51,3.51,0,0,1,.84-2.53,3.68,3.68,0,0,1,4.8,0,3.51,3.51,0,0,1,.84,2.53v7a4,4,0,0,1-.41,1.9.38.38,0,0,0,.2.24,1.3,1.3,0,0,0,.4.05h.19v1.9h-.29a2.48,2.48,0,0,1-1.17-.24,1.49,1.49,0,0,1-.67-.69,3.78,3.78,0,0,1-.7.18,3.94,3.94,0,0,1-.79.07,3.12,3.12,0,0,1-2.4-.88,3.53,3.53,0,0,1-.84-2.53Zm2.13,7.19a1.42,1.42,0,0,0,.3,1,1.23,1.23,0,0,0,1.61,0,1.42,1.42,0,0,0,.3-1v-7.33a1.45,1.45,0,0,0-.3-1,1.23,1.23,0,0,0-1.61,0,1.45,1.45,0,0,0-.3,1Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M188.51,199a3.29,3.29,0,0,0,1-.13,1.79,1.79,0,0,0,.65-.37,2,2,0,0,0,.4-.54,4.84,4.84,0,0,0,.28-.66h1.43V210.9h-2.13V200.55h-1.65Z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 263.63,
    y: 194.47,
    width: 25.45,
    height: 25.45,
    rx: 4.75,
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.63,
    y: 194.47,
    width: 25.45,
    height: 25.45,
    rx: 4.75,
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.63,
    y: 192.69,
    width: 25.45,
    height: 25.45,
    rx: 4.75,
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.63,
    y: 192.69,
    width: 25.45,
    height: 25.45,
    rx: 4.75,
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M269.89,201.77a3.53,3.53,0,0,1,.83-2.53,3.73,3.73,0,0,1,4.81,0,3.57,3.57,0,0,1,.83,2.53v7a4,4,0,0,1-.41,1.9.41.41,0,0,0,.21.25,1.24,1.24,0,0,0,.39,0h.2v1.9h-.29a2.48,2.48,0,0,1-1.17-.24,1.45,1.45,0,0,1-.67-.69,5.13,5.13,0,0,1-.7.19,5,5,0,0,1-.8.07,3.15,3.15,0,0,1-2.4-.89,3.51,3.51,0,0,1-.83-2.53ZM272,209a1.45,1.45,0,0,0,.3,1,1.23,1.23,0,0,0,1.61,0,1.45,1.45,0,0,0,.3-1v-7.33a1.42,1.42,0,0,0-.3-1,1.23,1.23,0,0,0-1.61,0,1.42,1.42,0,0,0-.3,1Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M282,201.85a1.83,1.83,0,0,0-.3-1.23,1,1,0,0,0-.8-.32,1.09,1.09,0,0,0-.81.3,1.42,1.42,0,0,0-.3,1v1.46h-2v-1.32a3.61,3.61,0,0,1,.8-2.53,3.64,3.64,0,0,1,4.75,0,3.61,3.61,0,0,1,.8,2.53,5.63,5.63,0,0,1-.33,2,7.78,7.78,0,0,1-.85,1.62,11.21,11.21,0,0,1-1.08,1.35c-.39.41-.74.8-1.05,1.16A5.74,5.74,0,0,0,280,209a1.8,1.8,0,0,0-.17,1.14h4v1.94h-6.16v-1.67a4.47,4.47,0,0,1,.31-1.74,6.29,6.29,0,0,1,.78-1.39,12.89,12.89,0,0,1,1-1.18,14.24,14.24,0,0,0,1-1.17,5.94,5.94,0,0,0,.78-1.37A4.38,4.38,0,0,0,282,201.85Z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 354.21,
    y: 193.47,
    width: 25.45,
    height: 25.45,
    rx: 4.75,
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354.21,
    y: 193.47,
    width: 25.45,
    height: 25.45,
    rx: 4.75,
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354.21,
    y: 191.69,
    width: 25.45,
    height: 25.45,
    rx: 4.75,
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354.21,
    y: 191.69,
    width: 25.45,
    height: 25.45,
    rx: 4.75,
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M360.48,200.77a3.57,3.57,0,0,1,.83-2.53,3.73,3.73,0,0,1,4.81,0,3.57,3.57,0,0,1,.83,2.53v7a3.85,3.85,0,0,1-.41,1.9.45.45,0,0,0,.21.25,1.28,1.28,0,0,0,.4,0h.19v1.9h-.29a2.48,2.48,0,0,1-1.17-.24,1.45,1.45,0,0,1-.67-.69,5.13,5.13,0,0,1-.7.19,5,5,0,0,1-.8.07,3.15,3.15,0,0,1-2.4-.89,3.55,3.55,0,0,1-.83-2.53Zm2.13,7.19a1.45,1.45,0,0,0,.3,1,1.23,1.23,0,0,0,1.61,0,1.45,1.45,0,0,0,.3-1v-7.33a1.42,1.42,0,0,0-.3-1,1.23,1.23,0,0,0-1.61,0,1.42,1.42,0,0,0-.3,1Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M372.44,200.85a1.83,1.83,0,0,0-.3-1.23,1,1,0,0,0-.81-.32,1.09,1.09,0,0,0-.8.3,1.42,1.42,0,0,0-.3,1v.88h-2v-.74a3.61,3.61,0,0,1,.81-2.53,3.63,3.63,0,0,1,4.74,0,3.61,3.61,0,0,1,.81,2.53v.35c0,1.44-.5,2.38-1.49,2.79a2.16,2.16,0,0,1,1.15,1.07,4.16,4.16,0,0,1,.34,1.78v1.06a3.59,3.59,0,0,1-.81,2.53,3.6,3.6,0,0,1-4.74,0,3.59,3.59,0,0,1-.81-2.53V206.7h2V208a1.45,1.45,0,0,0,.3,1,1.09,1.09,0,0,0,.8.3,1.1,1.1,0,0,0,.81-.31,1.82,1.82,0,0,0,.3-1.22V206.7a2.1,2.1,0,0,0-.33-1.34A1.33,1.33,0,0,0,371,205h-.72V203h.84a1.38,1.38,0,0,0,.94-.31,1.52,1.52,0,0,0,.34-1.13Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Hand--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M285.8,334.72l1.69,14.6c0,39.3-1.38,42.22-4.67,55.87-1.15,4.76-2.56,10.06-4.2,14.81a24.79,24.79,0,0,0-1.11,4.65v.07a26.58,26.58,0,0,0-.3,3.88,51.54,51.54,0,0,1-2.28,14.86c-1.75,6-4,12.82-6.51,20.05a219.71,219.71,0,0,1-72.73,7.28l23.4-43.18a22.47,22.47,0,0,0,2.36-14.7c-3-16.61-6.8-41.73-7.52-66.27-1.12-38.25,1.43-31.33,2.58-49.37A16,16,0,0,1,222.19,286l1.4-1.16,14.18-29.4a15.12,15.12,0,0,1,21.56-6.3l14.15,8.73a2.39,2.39,0,0,1,1.12,1.76l1.9,16.25s10.3,15.5,11,21.5c.22,2-1.9,7.67-1.9,7.67Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M217.73,430.43c22.7-20.21,17.22-41.93,8.35-54.6-7.1-10.13-2.81-22.65-2.9-33.94a152.41,152.41,0,0,0-2.51-24.57c-.7-4.06-1.5-8.11-2.31-12.15-.32-1.57-.29-3.11-.57-4.64s-1.28-2.89-1.08-4.45c0,0-3,23.44-3,25.46-.08,5,0,11.44,0,16.46.09,10.63.71,17.84,1.38,28.44,1.21,19.06,5.51,39.86,6.75,48.73C222.43,419.36,219.38,426.77,217.73,430.43Z",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M217.73,430.43c22.7-20.21,17.22-41.93,8.35-54.6-7.1-10.13-2.81-22.65-2.9-33.94a152.41,152.41,0,0,0-2.51-24.57c-.7-4.06-1.5-8.11-2.31-12.15-.32-1.57-.29-3.11-.57-4.64s-1.28-2.89-1.08-4.45c0,0-3,23.44-3,25.46-.08,5,0,11.44,0,16.46.09,10.63.71,17.84,1.38,28.44,1.21,19.06,5.51,39.86,6.75,48.73C222.43,419.36,219.38,426.77,217.73,430.43Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M253.36,256.94c-1.08-2.49-5.09-2.17-6.76,0s-1.69,5.09-1.6,7.8.15,5.66-1.45,7.86c-1,1.35-2.51,2.28-3.31,3.75-2.89,5.38,5.87,12.55,2,17.3-1.8,2.22-5.76,2.55-6.45,5.33-.78,3.08,3.14,4.93,5.53,7,4,3.47,3.86,10.56-.22,13.91,6.34,2.85,7.57,13.57,6.49,27.44,4.27-6,5.33-23.66,4.86-31s-2.21-14.56-2.84-21.89a72.32,72.32,0,0,1,5.28-33.81Z",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M253.36,256.94c-1.08-2.49-5.09-2.17-6.76,0s-1.69,5.09-1.6,7.8.15,5.66-1.45,7.86c-1,1.35-2.51,2.28-3.31,3.75-2.89,5.38,5.87,12.55,2,17.3-1.8,2.22-5.76,2.55-6.45,5.33-.78,3.08,3.14,4.93,5.53,7,4,3.47,3.86,10.56-.22,13.91,6.34,2.85,7.57,13.57,6.49,27.44,4.27-6,5.33-23.66,4.86-31s-2.21-14.56-2.84-21.89a72.32,72.32,0,0,1,5.28-33.81Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M276.05,311.46c-.46,3,.52,6.08,1.49,9q4.56,13.68,9.1,27.37c.16-11.61.49-23.23.49-34.83,0-3.1.9-8.59-3.09-9.48C280.36,302.7,276.49,308.62,276.05,311.46Z",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.05,311.46c-.46,3,.52,6.08,1.49,9q4.56,13.68,9.1,27.37c.16-11.61.49-23.23.49-34.83,0-3.1.9-8.59-3.09-9.48C280.36,302.7,276.49,308.62,276.05,311.46Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M331.62,147.05c0,.73,0,1.46,0,2.2a69.44,69.44,0,0,1-2.53,18.64,68.71,68.71,0,0,1-7.1,16.73l.23,0c-.71,1.22-1.46,2.41-2.24,3.58l-.24,0a69.89,69.89,0,0,1-40.39,28.58l-1.37.33-.78.18a69.13,69.13,0,0,1-15.33,1.7,69.83,69.83,0,0,1-10.79-.83,67.19,67.19,0,0,1-6.69-1.38c-1.69-.44-3.35-.93-5-1.49v.15q-1.92-.64-3.78-1.41a69.9,69.9,0,0,1-29.26-22.51c-.91-1.18-1.76-2.39-2.57-3.63-.54-.81-1.06-1.64-1.56-2.48-.8-1.32-1.56-2.66-2.27-4-.37-.71-.72-1.42-1.06-2.14-.19-.37-.36-.75-.53-1.13-.25-.55-.49-1.1-.73-1.66a69.79,69.79,0,0,1-5.41-27c0-1.34,0-2.67.11-4,.09-1.52.22-3,.41-4.53h0a69.66,69.66,0,0,1,27-47A70.26,70.26,0,0,1,235,85.1c1.51-.63,3.05-1.22,4.61-1.74a70,70,0,0,1,46,.43q2.26.81,4.46,1.78A69.06,69.06,0,0,1,297,89.08l.12,0c.68.39,1.36.8,2,1.24s1.35.86,2,1.31l.13.22q2.11,1.44,4.11,3a70.48,70.48,0,0,1,12.14,12.39c.68.89,1.33,1.8,2,2.72l.33.49c.54.81,1.08,1.61,1.59,2.44.63,1,1.24,2.07,1.82,3.13l.05.1h0a11.23,11.23,0,0,1,.53,1c.09.18.18.37.28.55.28.55.55,1.11.81,1.67a.3.3,0,0,1,0,.08l0,.06.06.12.05.1.07.16a.3.3,0,0,1,0,.08l.29.63a68.78,68.78,0,0,1,5.61,19.35l.18,2.12c.07.71.13,1.43.19,2.14s.08,1.3.11,2l0,0c0,.06,0,.12,0,.18C331.61,146.56,331.62,146.81,331.62,147.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.62,147.05c0,.73,0,1.46,0,2.2a69.44,69.44,0,0,1-2.53,18.64,68.71,68.71,0,0,1-7.1,16.73l.23,0c-.71,1.22-1.46,2.41-2.24,3.58l-.24,0a69.89,69.89,0,0,1-40.39,28.58l-1.37.33-.78.18a69.13,69.13,0,0,1-15.33,1.7,69.83,69.83,0,0,1-10.79-.83,67.19,67.19,0,0,1-6.69-1.38c-1.69-.44-3.35-.93-5-1.49v.15q-1.92-.64-3.78-1.41a69.9,69.9,0,0,1-29.26-22.51c-.91-1.18-1.76-2.39-2.57-3.63-.54-.81-1.06-1.64-1.56-2.48-.8-1.32-1.56-2.66-2.27-4-.37-.71-.72-1.42-1.06-2.14-.19-.37-.36-.75-.53-1.13-.25-.55-.49-1.1-.73-1.66a69.79,69.79,0,0,1-5.41-27c0-1.34,0-2.67.11-4,.09-1.52.22-3,.41-4.53h0a69.66,69.66,0,0,1,27-47A70.26,70.26,0,0,1,235,85.1c1.51-.63,3.05-1.22,4.61-1.74a70,70,0,0,1,46,.43q2.26.81,4.46,1.78A69.06,69.06,0,0,1,297,89.08l.12,0c.68.39,1.36.8,2,1.24s1.35.86,2,1.31l.13.22q2.11,1.44,4.11,3a70.48,70.48,0,0,1,12.14,12.39c.68.89,1.33,1.8,2,2.72l.33.49c.54.81,1.08,1.61,1.59,2.44.63,1,1.24,2.07,1.82,3.13l.05.1,1.63,3.22a.3.3,0,0,1,0,.08l0,.06.06.12.05.1.07.16a.3.3,0,0,1,0,.08l.29.63a68.78,68.78,0,0,1,5.61,19.35l.18,2.12c.07.71.13,1.43.19,2.14s.08,1.3.11,2l0,0c0,.06,0,.12,0,.18C331.61,146.56,331.62,146.81,331.62,147.05Z",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.53,141.05h-1.41l-2.9,0-8.68,0-8.75,0-8.35,0H242c0,.57,0,1.15,0,1.72h0c0,.65,0,1.3,0,1.94h0l.27.26c-.09.1-.18.18-.27.27h0v.39h0c2.92,0,5.85,0,8.76,0h.75l8,0,8.65-.07,8.55-.1,8.43-.12c.05-1.51.1-3,.14-4.54l1.14,0Zm59.07,5.27c0,.28-.05.56-.07.84-.56,7.16-1.36,14.13-2.4,20.73a69.44,69.44,0,0,0,2.53-18.64c0-.74,0-1.47,0-2.2C331.62,146.81,331.61,146.56,331.6,146.32Zm-59.07-5.27h-1.41l-2.9,0-8.68,0-8.75,0-8.35,0H242c0,.57,0,1.15,0,1.72h0c0,.65,0,1.3,0,1.94h0l.27.26c-.09.1-.18.18-.27.27h0v.39h0c2.92,0,5.85,0,8.76,0h.75l8,0,8.65-.07,8.55-.1,8.43-.12c.05-1.51.1-3,.14-4.54l1.14,0Zm0,0h-1.41l-2.9,0-8.68,0-8.75,0-8.35,0H242c0,.57,0,1.15,0,1.72h0c0,.65,0,1.3,0,1.94h0l.27.26c-.09.1-.18.18-.27.27h0v.39h0c2.92,0,5.85,0,8.76,0h.75l8,0,8.65-.07,8.55-.1,8.43-.12c.05-1.51.1-3,.14-4.54l1.14,0Zm0,0h-1.41l-2.9,0-8.68,0-8.75,0-8.35,0H242c0,.57,0,1.15,0,1.72h0c0,.65,0,1.3,0,1.94h0l.27.26c-.09.1-.18.18-.27.27h0v.39h0c2.92,0,5.85,0,8.76,0h.75l8,0,8.65-.07,8.55-.1,8.43-.12c.05-1.51.1-3,.14-4.54l1.14,0Zm0,0h-1.41l-2.9,0-8.68,0-8.75,0-8.35,0H242c0,.57,0,1.15,0,1.72h0c0,.65,0,1.3,0,1.94h0l.27.26c-.09.1-.18.18-.27.27h0v.39h0c2.92,0,5.85,0,8.76,0h.75l8,0,8.65-.07,8.55-.1,8.43-.12c.05-1.51.1-3,.14-4.54l1.14,0Zm0,0h-1.41l-2.9,0-8.68,0-8.75,0-8.35,0H242c0,.57,0,1.15,0,1.72h0c0,.65,0,1.3,0,1.94h0l.27.26c-.09.1-.18.18-.27.27h0v.39h0c2.92,0,5.85,0,8.76,0h.75l8,0,8.65-.07,8.55-.1,8.43-.12c.05-1.51.1-3,.14-4.54l1.14,0Zm0,0h-1.41l-2.9,0-8.68,0-8.75,0-8.35,0H242c0,.57,0,1.15,0,1.72h0c0,.65,0,1.3,0,1.94h0l.27.26c-.09.1-.18.18-.27.27h0v.39h0c2.92,0,5.85,0,8.76,0h.75l8,0,8.65-.07,8.55-.1,8.43-.12c.05-1.51.1-3,.14-4.54l1.14,0Zm0,0h-1.41l-2.9,0-8.68,0-8.75,0-8.35,0H242c0,.57,0,1.15,0,1.72h0c0,.65,0,1.3,0,1.94h0l.27.26c-.09.1-.18.18-.27.27h0v.39h0c2.92,0,5.85,0,8.76,0h.75l8,0,8.65-.07,8.55-.1,8.43-.12c.05-1.51.1-3,.14-4.54l1.14,0Zm0,0h-1.41l-2.9,0-8.68,0-8.75,0-8.35,0H242c0,.57,0,1.15,0,1.72h0c0,.65,0,1.3,0,1.94h0l.27.26h0l-.28.27v.4c2.92,0,5.85,0,8.76,0h.75l8,0,8.65-.07,8.55-.1,8.43-.12c.05-1.51.1-3,.14-4.54l1.14,0Zm0,0h-1.41l-2.9,0-8.68,0-8.75,0-8.35,0H242c0,.57,0,1.15,0,1.72h0c0,.65,0,1.3,0,1.94h0l.27.26h0l-.28.27v.4c2.92,0,5.85,0,8.76,0h.75l8,0,8.65-.07,8.55-.1,8.43-.12c.05-1.51.1-3,.14-4.54l1.14,0Zm12.72-.14,1.14,0-13.86.16h-1.41l-2.9,0-8.68,0-8.75,0-8.35,0H242c0,.57,0,1.15,0,1.72h0c0,.65,0,1.3,0,1.94h0l.27.26h0l-.28.27v.4h-2.33v1.89c0,14.87,0,28.95-.08,40.81,14.7,0,29.39-.35,43.41-1,.72-5.51,1.35-11.49,1.86-17.81.11-1.38.22-2.77.32-4.18.47-6.45.83-13.19,1.08-20.09l-1.14,0C285.16,143.94,285.21,142.43,285.25,140.91Zm1.2-37.33c0-.68,0-1.36-.05-2-.08-2.44-.16-4.85-.26-7.24-15-.32-30.72-.49-46.49-.5,0,14.55,0,30,0,45v2.42h0s0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0h0s0,0,0,0,0,0,0,0h0s0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0h0s0,0,0,0h0s0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0h0s0,0,0,0h0s0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0h0a0,0,0,0,0,0,0h0s0,0,0,0,0,0,0,0,0,0,0,0h0a0,0,0,0,0,0,0h.42a5.23,5.23,0,0,0,.56,0h.44l8.35,0,8.75,0,8.68,0,2.9,0h1.41l13.86-.16C286.75,128.57,286.77,115.87,286.45,103.58Zm-13.92,37.47h-1.41l-2.9,0-8.68,0-8.75,0-8.35,0H242c0,.57,0,1.15,0,1.72h0c0,.65,0,1.3,0,1.94h0l.27.26h0l-.28.27v.4c2.92,0,5.85,0,8.76,0h.75l8,0,8.65-.07,8.55-.1,8.43-.12c.05-1.51.1-3,.14-4.54l1.14,0Zm0,0h-1.41l-2.9,0-8.68,0-8.75,0-8.35,0H242c0,.57,0,1.15,0,1.72h0c0,.65,0,1.3,0,1.94h0l.27.26h0l-.28.27v.4c2.92,0,5.85,0,8.76,0h.75l8,0,8.65-.07,8.55-.1,8.43-.12c.05-1.51.1-3,.14-4.54l1.14,0Zm0,0h-1.41l-2.9,0-8.68,0-8.75,0-8.35,0H242c0,.57,0,1.15,0,1.72h0c0,.65,0,1.3,0,1.94h0l.27.26h0l-.28.27v.4c2.92,0,5.85,0,8.76,0h.75l8,0,8.65-.07,8.55-.1,8.43-.12c.05-1.51.1-3,.14-4.54l1.14,0Zm0,0h-1.41l-2.9,0-8.68,0-8.75,0-8.35,0H242c0,.57,0,1.15,0,1.72h0c0,.65,0,1.3,0,1.94h0l.27.26c-.09.1-.18.18-.27.27h0v.39h0c2.92,0,5.85,0,8.76,0h.75l8,0,8.65-.07,8.55-.1,8.43-.12c.05-1.51.1-3,.14-4.54l1.14,0Zm0,0h-1.41l-2.9,0-8.68,0-8.75,0-8.35,0H242c0,.57,0,1.15,0,1.72h0c0,.65,0,1.3,0,1.94h0l.27.26c-.09.1-.18.18-.27.27h0v.39h0c2.92,0,5.85,0,8.76,0h.75l8,0,8.65-.07,8.55-.1,8.43-.12c.05-1.51.1-3,.14-4.54l1.14,0Zm0,0h-1.41l-2.9,0-8.68,0-8.75,0-8.35,0H242c0,.57,0,1.15,0,1.72h0c0,.65,0,1.3,0,1.94h0l.27.26c-.09.1-.18.18-.27.27h0v.39h0c2.92,0,5.85,0,8.76,0h.75l8,0,8.65-.07,8.55-.1,8.43-.12c.05-1.51.1-3,.14-4.54l1.14,0Zm0,0h-1.41l-2.9,0-8.68,0-8.75,0-8.35,0H242c0,.57,0,1.15,0,1.72h0c0,.65,0,1.3,0,1.94h0l.27.26c-.09.1-.18.18-.27.27h0v.39h0c2.92,0,5.85,0,8.76,0h.75l8,0,8.65-.07,8.55-.1,8.43-.12c.05-1.51.1-3,.14-4.54l1.14,0Zm0,0h-1.41l-2.9,0-8.68,0-8.75,0-8.35,0H242c0,.57,0,1.15,0,1.72h0c0,.65,0,1.3,0,1.94h0l.27.26c-.09.1-.18.18-.27.27h0v.39h0c2.92,0,5.85,0,8.76,0h.75l8,0,8.65-.07,8.55-.1,8.43-.12c.05-1.51.1-3,.14-4.54l1.14,0Zm0,0h-1.41l-2.9,0-8.68,0-8.75,0-8.35,0H242c0,.57,0,1.15,0,1.72h0c0,.65,0,1.3,0,1.94h0l.27.26c-.09.1-.18.18-.27.27h0v.39h0c2.92,0,5.85,0,8.76,0h.75l8,0,8.65-.07,8.55-.1,8.43-.12c.05-1.51.1-3,.14-4.54l1.14,0Zm0,0h-1.41l-2.9,0-8.68,0-8.75,0-8.35,0H242c0,.57,0,1.15,0,1.72h0c0,.65,0,1.3,0,1.94h0l.27.26c-.09.1-.18.18-.27.27h0v.39h0c2.92,0,5.85,0,8.76,0h.75l8,0,8.65-.07,8.55-.1,8.43-.12c.05-1.51.1-3,.14-4.54l1.14,0Zm58.76,1-.18-2.12H331c-11.38.38-24.13.68-37.64.89l-2.59,0c0-.89.06-1.79.08-2.69.4-14.56.28-29.56-.36-43.73l1.69,0,4.15.11,9,.27q-2-1.59-4.11-3l-.13-.22c-.67-.45-1.34-.89-2-1.31h-.2l-4.39-.14L290.32,90c-.08-1.49-.16-3-.25-4.43q-2.19-1-4.46-1.78.18,3,.33,6.1c-14.91-.37-30.59-.56-46.29-.57,0-2,0-4,0-6-1.56.52-3.1,1.11-4.61,1.74,0,1.4,0,2.8,0,4.22l-8.44,0a68.38,68.38,0,0,0-6.74,4.53c5,0,10.1-.06,15.17-.07-.05,15.33-.06,31.67,0,47.38-13.88,0-27.7-.1-41-.27l-1.23,0h0c-.19,1.49-.32,3-.41,4.53.59,0,1.19,0,1.79,0,7.55.12,15.28.21,23.11.26l2.7,0,4.58,0,4.51,0H235c0,15.57.13,30.34.25,42.69-10.57,0-21.12-.24-31.39-.61h0c.81,1.24,1.66,2.45,2.57,3.63h0c9.46.34,19.14.52,28.83.55.1,9,.23,16.49.38,21.8V214q1.86.77,3.78,1.41v-.15c.06-5.35.1-13.39.13-23.21,14.53,0,29.05-.36,42.92-1q-.53,3.63-1.14,6.91h0c-.12.7-.25,1.38-.38,2.05-1.46,7.5-3.21,13.47-5.24,17.28-8.06.44-16.31.74-24.61.87a69.83,69.83,0,0,0,10.79.83,69.13,69.13,0,0,0,15.33-1.7l.78-.18,1.37-.33c2.94-5.3,5.34-14.44,7.18-25.95,11.72-.64,22.92-1.52,33.21-2.63l.24,0c.78-1.17,1.53-2.36,2.24-3.58l-.23,0c-10.76,1.15-22.55,2-34.93,2.69a420.14,420.14,0,0,0,3.55-42c13.8-.26,26.84-.62,38.51-1.09l.88,0,1.44-.06C331.42,143.45,331.36,142.73,331.29,142Z",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.53,141.05h-1.41l-2.9,0-8.68,0-8.75,0-8.35,0H242c0,.57,0,1.15,0,1.72h0c0,.65,0,1.3,0,1.94h0l.27.26c-.09.1-.18.18-.27.27h0v.39h0c2.92,0,5.85,0,8.76,0h.75l8,0,8.65-.07,8.55-.1,8.43-.12c.05-1.51.1-3,.14-4.54l1.14,0Zm59.09,6c0-.24,0-.49,0-.73,0,.28-.05.56-.07.84-.56,7.16-1.36,14.13-2.4,20.73a69.44,69.44,0,0,0,2.53-18.64C331.66,148.51,331.65,147.78,331.62,147.05Zm-59.09-6h-1.41l-2.9,0-8.68,0-8.75,0-8.35,0H242c0,.57,0,1.15,0,1.72h0c0,.65,0,1.3,0,1.94h0l.27.26c-.09.1-.18.18-.27.27h0v.39h0c2.92,0,5.85,0,8.76,0h.75l8,0,8.65-.07,8.55-.1,8.43-.12c.05-1.51.1-3,.14-4.54l1.14,0Zm0,0h-1.41l-2.9,0-8.68,0-8.75,0-8.35,0H242c0,.57,0,1.15,0,1.72h0c0,.65,0,1.3,0,1.94h0l.27.26c-.09.1-.18.18-.27.27h0v.39h0c2.92,0,5.85,0,8.76,0h.75l8,0,8.65-.07,8.55-.1,8.43-.12c.05-1.51.1-3,.14-4.54l1.14,0Zm0,0h-1.41l-2.9,0-8.68,0-8.75,0-8.35,0H242c0,.57,0,1.15,0,1.72h0c0,.65,0,1.3,0,1.94h0l.27.26c-.09.1-.18.18-.27.27h0v.39h0c2.92,0,5.85,0,8.76,0h.75l8,0,8.65-.07,8.55-.1,8.43-.12c.05-1.51.1-3,.14-4.54l1.14,0Zm0,0h-1.41l-2.9,0-8.68,0-8.75,0-8.35,0H242c0,.57,0,1.15,0,1.72h0c0,.65,0,1.3,0,1.94h0l.27.26c-.09.1-.18.18-.27.27h0v.39h0c2.92,0,5.85,0,8.76,0h.75l8,0,8.65-.07,8.55-.1,8.43-.12c.05-1.51.1-3,.14-4.54l1.14,0Zm0,0h-1.41l-2.9,0-8.68,0-8.75,0-8.35,0H242c0,.57,0,1.15,0,1.72h0c0,.65,0,1.3,0,1.94h0l.27.26c-.09.1-.18.18-.27.27h0v.39h0c2.92,0,5.85,0,8.76,0h.75l8,0,8.65-.07,8.55-.1,8.43-.12c.05-1.51.1-3,.14-4.54l1.14,0Zm0,0h-1.41l-2.9,0-8.68,0-8.75,0-8.35,0H242c0,.57,0,1.15,0,1.72h0c0,.65,0,1.3,0,1.94h0l.27.26c-.09.1-.18.18-.27.27h0v.39h0c2.92,0,5.85,0,8.76,0h.75l8,0,8.65-.07,8.55-.1,8.43-.12c.05-1.51.1-3,.14-4.54l1.14,0Zm0,0h-1.41l-2.9,0-8.68,0-8.75,0-8.35,0H242c0,.57,0,1.15,0,1.72h0c0,.65,0,1.3,0,1.94h0l.27.26c-.09.1-.18.18-.27.27h0v.39h0c2.92,0,5.85,0,8.76,0h.75l8,0,8.65-.07,8.55-.1,8.43-.12c.05-1.51.1-3,.14-4.54l1.14,0Zm0,0h-1.41l-2.9,0-8.68,0-8.75,0-8.35,0H242c0,.57,0,1.15,0,1.72h0c0,.65,0,1.3,0,1.94h0l.27.26h0l-.28.27v.4c2.92,0,5.85,0,8.76,0h.75l8,0,8.65-.07,8.55-.1,8.43-.12c.05-1.51.1-3,.14-4.54l1.14,0Zm0,0h-1.41l-2.9,0-8.68,0-8.75,0-8.35,0H242c0,.57,0,1.15,0,1.72h0c0,.65,0,1.3,0,1.94h0l.27.26h0l-.28.27v.4c2.92,0,5.85,0,8.76,0h.75l8,0,8.65-.07,8.55-.1,8.43-.12c.05-1.51.1-3,.14-4.54l1.14,0Zm0,0h-1.41l-2.9,0-8.68,0-8.75,0-8.35,0H242c0,.57,0,1.15,0,1.72h0c0,.65,0,1.3,0,1.94h0l.27.26h0l-.28.27v.4c2.92,0,5.85,0,8.76,0h.75l8,0,8.65-.07,8.55-.1,8.43-.12c.05-1.51.1-3,.14-4.54l1.14,0Zm0,0h-1.41l-2.9,0-8.68,0-8.75,0-8.35,0H242c0,.57,0,1.15,0,1.72h0c0,.65,0,1.3,0,1.94h0l.27.26h0l-.28.27v.4c2.92,0,5.85,0,8.76,0h.75l8,0,8.65-.07,8.55-.1,8.43-.12c.05-1.51.1-3,.14-4.54l1.14,0Zm0,0h-1.41l-2.9,0-8.68,0-8.75,0-8.35,0H242c0,.57,0,1.15,0,1.72h0c0,.65,0,1.3,0,1.94h0l.27.26h0l-.28.27v.4c2.92,0,5.85,0,8.76,0h.75l8,0,8.65-.07,8.55-.1,8.43-.12c.05-1.51.1-3,.14-4.54l1.14,0Zm0,0h-1.41l-2.9,0-8.68,0-8.75,0-8.35,0H242c0,.57,0,1.15,0,1.72h0c0,.65,0,1.3,0,1.94h0l.27.26h0l-.28.27v.4c2.92,0,5.85,0,8.76,0h.75l8,0,8.65-.07,8.55-.1,8.43-.12c.05-1.51.1-3,.14-4.54l1.14,0Zm0,0h-1.41l-2.9,0-8.68,0-8.75,0-8.35,0H242c0,.57,0,1.15,0,1.72h0c0,.65,0,1.3,0,1.94h0l.27.26c-.09.1-.18.18-.27.27h0v.39h0c2.92,0,5.85,0,8.76,0h.75l8,0,8.65-.07,8.55-.1,8.43-.12c.05-1.51.1-3,.14-4.54l1.14,0Zm0,0h-1.41l-2.9,0-8.68,0-8.75,0-8.35,0H242c0,.57,0,1.15,0,1.72h0c0,.65,0,1.3,0,1.94h0l.27.26c-.09.1-.18.18-.27.27h0v.39h0c2.92,0,5.85,0,8.76,0h.75l8,0,8.65-.07,8.55-.1,8.43-.12c.05-1.51.1-3,.14-4.54l1.14,0Zm0,0h-1.41l-2.9,0-8.68,0-8.75,0-8.35,0H242c0,.57,0,1.15,0,1.72h0c0,.65,0,1.3,0,1.94h0l.27.26c-.09.1-.18.18-.27.27h0v.39h0c2.92,0,5.85,0,8.76,0h.75l8,0,8.65-.07,8.55-.1,8.43-.12c.05-1.51.1-3,.14-4.54l1.14,0Zm0,0h-1.41l-2.9,0-8.68,0-8.75,0-8.35,0H242c0,.57,0,1.15,0,1.72h0c0,.65,0,1.3,0,1.94h0l.27.26c-.09.1-.18.18-.27.27h0v.39h0c2.92,0,5.85,0,8.76,0h.75l8,0,8.65-.07,8.55-.1,8.43-.12c.05-1.51.1-3,.14-4.54l1.14,0Zm0,0h-1.41l-2.9,0-8.68,0-8.75,0-8.35,0H242c0,.57,0,1.15,0,1.72h0c0,.65,0,1.3,0,1.94h0l.27.26c-.09.1-.18.18-.27.27h0v.39h0c2.92,0,5.85,0,8.76,0h.75l8,0,8.65-.07,8.55-.1,8.43-.12c.05-1.51.1-3,.14-4.54l1.14,0Zm0,0h-1.41l-2.9,0-8.68,0-8.75,0-8.35,0H242c0,.57,0,1.15,0,1.72h0c0,.65,0,1.3,0,1.94h0l.27.26c-.09.1-.18.18-.27.27h0v.39h0c2.92,0,5.85,0,8.76,0h.75l8,0,8.65-.07,8.55-.1,8.43-.12c.05-1.51.1-3,.14-4.54l1.14,0Zm0,0h-1.41l-2.9,0-8.68,0-8.75,0-8.35,0H242c0,.57,0,1.15,0,1.72h0c0,.65,0,1.3,0,1.94h0l.27.26c-.09.1-.18.18-.27.27h0v.39h0c2.92,0,5.85,0,8.76,0h.75l8,0,8.65-.07,8.55-.1,8.43-.12c.05-1.51.1-3,.14-4.54l1.14,0Zm58.76,1-.18-2.12H331c-11.38.38-24.13.68-37.64.89l-2.59,0c0-.89.06-1.79.08-2.69.4-14.56.28-29.56-.36-43.73l1.69,0,4.15.11,9,.27q-2-1.59-4.11-3l-.13-.22c-.67-.45-1.34-.89-2-1.31h-.2l-4.39-.14L290.32,90c-.08-1.49-.16-3-.25-4.43q-2.19-1-4.46-1.78.18,3,.33,6.1c-14.91-.37-30.59-.56-46.29-.57,0-2,0-4,0-6-1.56.52-3.1,1.11-4.61,1.74,0,1.4,0,2.8,0,4.22l-8.44,0a68.38,68.38,0,0,0-6.74,4.53c5,0,10.1-.06,15.17-.07-.05,15.33-.06,31.67,0,47.38-13.88,0-27.7-.1-41-.27l-1.23,0h0c-.19,1.49-.32,3-.41,4.53.59,0,1.19,0,1.79,0,7.55.12,15.28.21,23.11.26l2.7,0,4.58,0,4.51,0H235c0,15.57.13,30.34.25,42.69-10.57,0-21.12-.24-31.39-.61h0c.81,1.24,1.66,2.45,2.57,3.63h0c9.46.34,19.14.52,28.83.55.1,9,.23,16.49.38,21.8V214q1.86.77,3.78,1.41v-.15c.06-5.35.1-13.39.13-23.21,14.53,0,29.05-.36,42.92-1q-.53,3.63-1.14,6.91h0c-.12.7-.25,1.38-.38,2.05-1.46,7.5-3.21,13.47-5.24,17.28-8.06.44-16.31.74-24.61.87a69.83,69.83,0,0,0,10.79.83,69.13,69.13,0,0,0,15.33-1.7l.78-.18,1.37-.33c2.94-5.3,5.34-14.44,7.18-25.95,11.72-.64,22.92-1.52,33.21-2.63l.24,0c.78-1.17,1.53-2.36,2.24-3.58l-.23,0c-10.76,1.15-22.55,2-34.93,2.69a420.14,420.14,0,0,0,3.55-42c13.8-.26,26.84-.62,38.51-1.09l.88,0,1.44-.06C331.42,143.45,331.36,142.73,331.29,142Zm-46.12,23.5c-.1,1.41-.21,2.8-.32,4.18-.51,6.32-1.14,12.3-1.86,17.81-14,.66-28.71,1-43.41,1,0-11.86.06-25.94.08-40.81v-1.89H242c2.92,0,5.85,0,8.76,0h.75l8,0,8.65-.07,8.55-.1,8.43-.12,1.14,0C286,152.33,285.64,159.07,285.17,165.52Zm1.22-24.63-13.86.16h-1.41l-2.9,0-8.68,0-8.75,0-8.35,0H242a5.23,5.23,0,0,1-.56,0H241a0,0,0,0,1,0,0h0s0,0,0,0,0,0,0,0,0,0,0,0h0a0,0,0,0,1,0,0h0s0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0h0s0,0,0,0h0s0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0h0s0,0,0,0h0s0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0h0s0,0,0,0,0,0,0,0h0s0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0h0v-2.42c0-15,0-30.42,0-45,15.77,0,31.52.18,46.49.5.1,2.39.18,4.8.26,7.24,0,.67,0,1.35.05,2C286.77,115.87,286.75,128.57,286.39,140.89Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.25,145.43c-.25,6.9-.61,13.64-1.08,20.09-.1,1.41-.21,2.8-.32,4.18-.51,6.32-1.14,12.3-1.86,17.81-14,.66-28.71,1-43.41,1,0-11.86.06-25.94.08-40.81v-1.89H242c2.92,0,5.85,0,8.76,0h.75l8,0,8.65-.07,8.55-.1,8.43-.12Z",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.39,140.89l-13.86.16h-1.41l-2.9,0-8.68,0-8.75,0-8.35,0H242a5.23,5.23,0,0,1-.56,0H241a0,0,0,0,1,0,0h0s0,0,0,0,0,0,0,0,0,0,0,0h0a0,0,0,0,1,0,0h0s0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0h0s0,0,0,0h0s0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0h0s0,0,0,0h0s0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0h0s0,0,0,0,0,0,0,0h0s0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0h0v-2.42c0-15,0-30.42,0-45,15.77,0,31.52.18,46.49.5.1,2.39.18,4.8.26,7.24,0,.67,0,1.35.05,2C286.77,115.87,286.75,128.57,286.39,140.89Z",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.43,145.14l-3.77-3.26,3.77-3.28,3.77,3.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.29,91.8l-.13-.22c-.67-.45-1.34-.89-2-1.31s-1.35-.85-2-1.24l-.12,0-2.44,1-.86.37-2.95,2.66,1.48,1.3,2.17,1.92,2-1.81.42-.38,4.71-2Zm-14.89,9.75-2.52-2.23q-3.48,3.14-7.09,6.34L280.5,109l5.95-5.37,1.11-1Zm-16.89,10.59-7.42,6.58,3.74,3.31q3.74-3.3,7.41-6.58Zm-14.94,13.21L247,132l3.76,3.3,7.56-6.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M315.83,115.41l-3.93,0L308,119.59l2.93,3.2c.9-1,1.79-2,2.67-2.92h2.23C315.86,118.39,315.85,116.9,315.83,115.41ZM302.4,125.63q-2.86,3-5.81,6.11,1.52,1.6,3,3.19,2.94-3.06,5.79-6.1C304.38,127.77,303.4,126.7,302.4,125.63Zm-51.61,15.55c0,1.54,0,3.08,0,4.61h.75l8,0c0-1.52,0-3.06.06-4.6Zm21.74-.13h-1.41l-2.9,0h0c0,1.54-.06,3.06-.09,4.58l8.55-.1c.05-1.51.09-3,.12-4.56Zm20.87-.26-2.51-2.65-.25-.26c-1,1-2,2-2.95,3l-1.3,0-1.14,0c0,1.52-.09,3-.14,4.54l1.14,0,3.11-.05,4.28-4.33Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M242,145.82h-4.67V141.2H242C242,142.75,242,144.28,242,145.82Z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M315.83,115.41l-3.93,0L308,119.59l2.93,3.2c.9-1,1.79-2,2.67-2.92h2.23C315.86,118.39,315.85,116.9,315.83,115.41ZM302.4,125.63q-2.86,3-5.81,6.11,1.52,1.6,3,3.19,2.94-3.06,5.79-6.1C304.38,127.77,303.4,126.7,302.4,125.63Zm-51.61,15.55c0,1.54,0,3.08,0,4.61h.75l8,0c0-1.52,0-3.06.06-4.6Zm21.74-.13h-1.41l-2.9,0h0c0,1.54-.06,3.06-.09,4.58l8.55-.1c.05-1.51.09-3,.12-4.56Zm20.87-.26-2.51-2.65-.25-.26c-1,1-2,2-2.95,3l-1.3,0-1.14,0c0,1.52-.09,3-.14,4.54l1.14,0,3.11-.05,4.28-4.33Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M242,145.82h-4.67V141.2H242C242,142.75,242,144.28,242,145.82Z"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M239,148.39l-3.3-3.25,3.3-3.26,3.3,3.26Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M331.6,146.32c0-.06,0-.12,0-.18l0,0L330,144.22c-.13-.16-.26-.33-.4-.49l-.48.53c-1.79,2-3.63,4-5.49,6,.82,1,1.62,1.91,2.41,2.86,1.85-2,3.68-4,5.45-6a.44.44,0,0,0,.09-.11C331.62,146.81,331.61,146.56,331.6,146.32Zm-82.54,5.5-3.3,3.2q3.36,3.27,6.66,6.46l3.3-3.13Q252.42,155.13,249.06,151.82Zm68.4,4.93Q314.3,160,311,163.2c.84.92,1.66,1.84,2.47,2.75q3.24-3.18,6.39-6.39ZM263.62,166l-1.41-1.37-3.29,3.07,2.67,2.55,7.21-.13c.07-1.39.14-2.8.21-4.22Zm21.55-.52c-2.3.08-4.63.15-7,.21-.09,1.41-.18,2.81-.28,4.19q3.49-.09,6.92-.22l2.06-.07c.12-1.38.23-2.77.34-4.17C286.56,165.48,285.87,165.51,285.17,165.52Zm10.92-.39q-.18,2.1-.39,4.14c2.89-.12,5.75-.26,8.56-.41.15-1.36.3-2.73.44-4.11C301.87,164.89,299,165,296.09,165.13Z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M239,148.39l-3.3-3.25,3.3-3.26,3.3,3.26Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M331.6,146.32c0-.06,0-.12,0-.18l0,0L330,144.22c-.13-.16-.26-.33-.4-.49l-.48.53c-1.79,2-3.63,4-5.49,6,.82,1,1.62,1.91,2.41,2.86,1.85-2,3.68-4,5.45-6a.44.44,0,0,0,.09-.11C331.62,146.81,331.61,146.56,331.6,146.32Zm-82.54,5.5-3.3,3.2q3.36,3.27,6.66,6.46l3.3-3.13Q252.42,155.13,249.06,151.82Zm68.4,4.93Q314.3,160,311,163.2c.84.92,1.66,1.84,2.47,2.75q3.24-3.18,6.39-6.39ZM263.62,166l-1.41-1.37-3.29,3.07,2.67,2.55,7.21-.13c.07-1.39.14-2.8.21-4.22Zm21.55-.52c-2.3.08-4.63.15-7,.21-.09,1.41-.18,2.81-.28,4.19q3.49-.09,6.92-.22l2.06-.07c.12-1.38.23-2.77.34-4.17C286.56,165.48,285.87,165.51,285.17,165.52Zm10.92-.39q-.18,2.1-.39,4.14c2.89-.12,5.75-.26,8.56-.41.15-1.36.3-2.73.44-4.11C301.87,164.89,299,165,296.09,165.13Z"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M282.66,203.87c-.22.95-.46,1.85-.7,2.73l0,.19-.24.87c-.3,1.06-.6,2.07-.92,3-.06.14-.1.28-.15.42l-.18.52c-.05.17-.12.34-.18.51a7.66,7.66,0,0,1-.27.72c-.42,1.11-.85,2.12-1.3,3-.18.38-.37.74-.56,1.09l-.09.13-.78.18a69.13,69.13,0,0,1-15.33,1.7,69.83,69.83,0,0,1-10.79-.83,67.19,67.19,0,0,1-6.69-1.38c0-.34,0-.69.07-1.06s.06-.94.09-1.44.06-1,.09-1.56.06-1.1.08-1.68c0-.29,0-.58,0-.88.07-1.56.14-3.25.21-5.06.08-2.74,3.44-5.27,7.5-5.33,8.19-.14,16.3-.39,24.24-.76a7,7,0,0,1,4.22,1A3.48,3.48,0,0,1,282.66,203.87Z",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M282.66,203.87c-.22.95-.46,1.85-.7,2.73l0,.19-.24.87c-.3,1.06-.6,2.07-.92,3-.06.14-.1.28-.15.42l-.18.52c-.05.17-.12.34-.18.51a7.66,7.66,0,0,1-.27.72c-.42,1.11-.85,2.12-1.3,3-.18.38-.37.74-.56,1.09l-.09.13-.78.18a69.13,69.13,0,0,1-15.33,1.7,69.83,69.83,0,0,1-10.79-.83,67.19,67.19,0,0,1-6.69-1.38c0-.34,0-.69.07-1.06s.06-.94.09-1.44.06-1,.09-1.56.06-1.1.08-1.68c0-.29,0-.58,0-.88.07-1.56.14-3.25.21-5.06.08-2.74,3.44-5.27,7.5-5.33,8.19-.14,16.3-.39,24.24-.76a7,7,0,0,1,4.22,1A3.48,3.48,0,0,1,282.66,203.87Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M283.1,202c-.14.64-.29,1.27-.44,1.88-.22.95-.46,1.85-.7,2.73l0,.19-.24.87c-.3,1.06-.6,2.07-.92,3-.11.32-.21.63-.33.94s-.12.34-.18.51a7.66,7.66,0,0,1-.27.72c-.42,1.11-.85,2.12-1.3,3a3.7,3.7,0,0,1-1.43,1.4,69.13,69.13,0,0,1-15.33,1.7,69.83,69.83,0,0,1-10.79-.83,67.19,67.19,0,0,1-6.69-1.38c0-.34,0-.69.07-1.06s.06-.94.09-1.44.06-1,.09-1.56.06-1.1.08-1.68c0-.29,0-.58,0-.88.07-1.56.14-3.25.21-5.06q0-.93.06-1.89c.08-2.85,3.47-5.47,7.57-5.53,8.25-.14,16.44-.39,24.45-.76a7.11,7.11,0,0,1,4.26,1h0A3.72,3.72,0,0,1,283.1,202Z",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M283.1,202c-.14.64-.29,1.27-.44,1.88-.22.95-.46,1.85-.7,2.73l0,.19-.24.87c-.3,1.06-.6,2.07-.92,3-.11.32-.21.63-.33.94s-.12.34-.18.51a7.66,7.66,0,0,1-.27.72c-.42,1.11-.85,2.12-1.3,3a3.7,3.7,0,0,1-1.43,1.4,69.13,69.13,0,0,1-15.33,1.7,69.83,69.83,0,0,1-10.79-.83,67.19,67.19,0,0,1-6.69-1.38c0-.34,0-.69.07-1.06s.06-.94.09-1.44.06-1,.09-1.56.06-1.1.08-1.68c0-.29,0-.58,0-.88.07-1.56.14-3.25.21-5.06q0-.93.06-1.89c.08-2.85,3.47-5.47,7.57-5.53,8.25-.14,16.44-.39,24.45-.76a7.11,7.11,0,0,1,4.26,1h0A3.72,3.72,0,0,1,283.1,202Z",
    style: {
      fill: "#fff"
    }
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M262.53,213.47c.4-1.82.79-3.89,1.15-6.18a2.47,2.47,0,0,0-.86-2.51,5.32,5.32,0,0,0-3.47-.83,6.6,6.6,0,0,0-3.69,1,3.45,3.45,0,0,0-1.49,2.58q-.34,3.44-.72,6.17a1.64,1.64,0,0,0,.87,1.82,6.34,6.34,0,0,0,3.18.52c.39,0,.76,0,1.1-.07s.67-.09,1-.15a1.41,1.41,0,0,0,.8.42,5.77,5.77,0,0,0,1.55.11h.39c.12-.41.24-.84.35-1.29h-.26a4.15,4.15,0,0,1-.54,0,.33.33,0,0,1-.24-.17A2.53,2.53,0,0,0,262.53,213.47Zm-1.95-6.22c-.33,2.39-.68,4.54-1.05,6.42a1.05,1.05,0,0,1-.58.79,2.65,2.65,0,0,1-1.16.25,2.05,2.05,0,0,1-1.08-.19.66.66,0,0,1-.28-.77c.32-1.87.62-4,.9-6.41a1.33,1.33,0,0,1,.56-1,2.29,2.29,0,0,1,1.23-.33,1.77,1.77,0,0,1,1.15.27A1,1,0,0,1,260.58,207.25Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M274.27,204.33a4.75,4.75,0,0,0-3.32-.77,6.54,6.54,0,0,0-3.66,1.07,3.88,3.88,0,0,0-1.6,2.59c-.07.43-.15.85-.22,1.26l2.91-.11c.09-.46.18-.92.27-1.4a1.51,1.51,0,0,1,.62-1,2.38,2.38,0,0,1,1.24-.35,1.64,1.64,0,0,1,1.11.27c.25.2.31.61.19,1.2a3.69,3.69,0,0,1-.8,1.65,7.48,7.48,0,0,1-1.4,1.28,17.93,17.93,0,0,1-1.68,1.09,19.53,19.53,0,0,0-1.66,1.05,7.85,7.85,0,0,0-1.36,1.15,3,3,0,0,0-.77,1.32c-.1.41-.21.8-.32,1.17q4.2-.15,8.34-.36c.17-.43.33-.89.49-1.37-1.83.09-3.67.18-5.52.25a1.21,1.21,0,0,1,.48-.87,9,9,0,0,1,1.26-.9q.76-.48,1.71-1a16.72,16.72,0,0,0,1.83-1.23,9.24,9.24,0,0,0,1.55-1.51,4.47,4.47,0,0,0,.93-1.92A2.38,2.38,0,0,0,274.27,204.33Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M237.32,141.2v4.62H235l-5.92,0-4.51,0-4.58,0-2.7,0c-7.83-.05-15.56-.14-23.11-.26-.6,0-1.2,0-1.79,0,.09-1.52.22-3,.41-4.53H194c13.26.17,27.08.25,41,.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 237.32,
    cy: 143.6,
    r: 4.91,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.75,149.33a69.57,69.57,0,1,1-8.05-32.55A69.75,69.75,0,0,1,331.75,149.33Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.75,149.33A69.75,69.75,0,0,1,262,219.08Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.19,165.68a69.82,69.82,0,0,1,87.33-83.34Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.7,116.78,227.58,210a69.87,69.87,0,0,1-15.71-12.2L311.6,100.3A69.51,69.51,0,0,1,323.7,116.78Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "302.07 219.81 273.94 240.41 250.06 240.41 221.94 219.81 302.07 219.81",
    style: {
      fill: "#c9cccd",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262,68.27a81.07,81.07,0,0,0-40.06,151.55h0A81.07,81.07,0,1,0,262,68.27Zm0,150.81a69.75,69.75,0,1,1,69.75-69.75A69.74,69.74,0,0,1,262,219.08Z",
    style: {
      fill: "#c9cccd",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250.06,
    y: 240.41,
    width: 22.81,
    height: 142.06,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.68,89.33a62.47,62.47,0,0,1,14.7-1.74",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.09,149.87a62.29,62.29,0,0,1,36.57-56.74",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285,338.51c-10.67-29.42-10.62-34.19-11.24-52-.2-5.56-.09-11.19-1.41-16.6s-4.63-12.49-10.14-13.31c-4.05-.61-8.05,2-10.21,5.49s-2.82,7.67-3.21,11.75a112.75,112.75,0,0,0,2.95,38.86c-3.93,9.05-2.43,15.82-4.9,29.61v58h35.53S291.89,357.63,285,338.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.06,400.24s7.83-42.61.89-61.73c-10.67-29.42-10.62-34.19-11.24-52-.2-5.56-.09-11.19-1.41-16.6s-4.63-12.49-10.14-13.31c-4.05-.61-8.05,2-10.21,5.49s-2.82,7.67-3.21,11.75a112.75,112.75,0,0,0,2.95,38.86c-3.93,9.05-2.43,15.82-4.9,29.61",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.5,276a9.64,9.64,0,0,1-2.68,9.28",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.87,262.49a32.4,32.4,0,0,1,0,8.52,23.28,23.28,0,0,1-13.45.47,15.5,15.5,0,0,1-.28-7.74",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.36,323.25c.42,1.67.68,2.7,1,3.9",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251,310c.33,1.35,1.7,6.76,2.9,11.57",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.7,323.05c0,2.11.11,4,.25,5.65",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.2,296.56c.59,7.35.34,15.38.44,23.11",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.77,303.6a122.33,122.33,0,0,1-8.84,10.45",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.67,325.65a18,18,0,0,0,4.67-4.81",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.05,321.18c1.78,7-2.29,14.37-1.49,21.59",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216,305c.43,4.15.75,7.32,1.18,11.47",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232,385.55c.78,1.18,1.56,2.33,2.35,3.44",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.34,351c.24,8.06,5.72,20.13,12.34,30.87",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.92,277.35l11.13-.85",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.11,283.35c-3.07,1.59,12.1-3.68,12.78-3.74",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254,287.44c-1.12.59,10.94-2.15,13.46-1.46",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.64,296.49a25,25,0,0,0,14.26-2.84",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248,254.22c1.54,2.72,3.63,4.6,3.69,7.72",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.92,270.87a55.55,55.55,0,0,1,5.94,5.46",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.2,295.33a8,8,0,0,1,7.32.27",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.55,296.56c3,1,6.6,3.31,10.86,4.8",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.81,309.71,241.89,315",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.66,465a194.1,194.1,0,0,0,14.85-40.33",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-2--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M280.5,413.5c-1.53,4.87-5.58,20.68-6.12,21.42a166.14,166.14,0,0,1,1.65-20,47.7,47.7,0,0,1,3.17-11.67c2.05-5,5.4-13.43,8.54-22.81C287.74,380.43,285.22,398.51,280.5,413.5Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M268.41,463.51c2.52-7.23,4.76-14.08,6.51-20.05a51.54,51.54,0,0,0,2.28-14.86,26.58,26.58,0,0,1,.3-3.88v-.07a24.79,24.79,0,0,1,1.11-4.65c1.64-4.75,3.05-10.05,4.2-14.81,3.29-13.65,4.66-16.57,4.67-55.87l-1.69-14.6-.21-29.63s2.12-5.71,1.9-7.67c-.69-6-11-21.5-11-21.5l-1.9-16.25a2.39,2.39,0,0,0-1.12-1.76l-14.15-8.73a15.11,15.11,0,0,0-21.56,6.3l-14.18,29.4-1.4,1.16a16,16,0,0,0-5.69,11.23c-1.15,18-3.7,11.12-2.58,49.37.72,24.54,4.5,49.66,7.52,66.27a22.47,22.47,0,0,1-2.36,14.7l-23.4,43.18",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg7);
export default __webpack_public_path__ + "static/media/img7.1e8503c8e33f7baac7e930223fa2a77e.svg";
export { ForwardRef as ReactComponent };